import axios from 'axios';

//axios.defaults.baseURL = 'http://localhost:8000/api/v1/';
axios.defaults.baseURL = 'https://nexteraenergy.storycapture.com/api/api/v1/';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        window.console.log('not authorized');
    } else {
        return Promise.reject(error);
    }
});

axios.interceptors.request.use(function(config) {
    const token = localStorage.getItem('token');
    if(token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});